import HotelsSearchControlsGC, {
  fetchSuggestions,
} from '@skyscanner-internal/global-components/hotels-search-controls';
import logger from 'saddlebag-logger';

import getDayviewUrl from './utils/url';

import type { RequiredSearchParams } from '@skyscanner-internal/global-components/hotels-search-controls/common/types/search';
import type { HotelsSearchControlsGCWrapperProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/HotelsSearchControlsGCWrapperProps';
import type { MappingShape } from '@skyscanner-internal/landing-pages-shared-types/types-shared/hotels-components/types';

const redirectOnSubmit = ({
  adults,
  checkInDate,
  checkOutDate,
  childrenAges,
  destination,
  filter,
  rooms,
}: RequiredSearchParams) => {
  window.location.assign(
    getDayviewUrl({
      destination,
      checkInDate,
      checkOutDate,
      adults,
      rooms,
      childrenAges,
      filter,
    }),
  );
};

const createRedirectWithFilter =
  (presetFilter: MappingShape | undefined) =>
  (params: RequiredSearchParams) => {
    const mergedFilter = {
      ...presetFilter,
      ...params.filter,
    };

    redirectOnSubmit({
      ...params,
      filter: mergedFilter,
    });
  };

const HotelsSearchControlsGCWrapper = ({
  autosuggestExpVal,
  cldr,
  device,
  enableShowExpandedInputValue,
  filters,
  isProductionEnv,
  isWebView,
  searchParams,
  strings,
  trackingProps,
  utid,
}: HotelsSearchControlsGCWrapperProps) => (
  <HotelsSearchControlsGC
    cldr={cldr}
    device={device}
    featureDecisions={{
      autosuggestExpVal,
      enableShowExpandedInputValue,
    }}
    isProductionEnv={isProductionEnv}
    isWebView={isWebView}
    logger={logger}
    onSearch={createRedirectWithFilter(filters)}
    onSuggestionRequest={fetchSuggestions}
    searchParams={searchParams}
    showPreference
    strings={strings}
    trackingProps={trackingProps}
    utid={utid}
    enableRecentSearch
  />
);

export default HotelsSearchControlsGCWrapper;
